module.exports = __webpack_public_path__ + "media/images/brand/threads_link-862e8b134a4385b839d9e5e5a933b767.svg";